import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const WAF: React.FC = () => {
  const sections = [
    {
      title: 'Web Application Firewall (WAF)',
      content: 'Our WAF solutions protect your web applications from common attacks and vulnerabilities including SQL injection, cross-site scripting, and DDoS attacks. We deploy and manage enterprise-grade WAF solutions that provide real-time protection and threat intelligence.',
      benefits: [
        'OWASP Top 10 attack protection',
        'Real-time threat detection and blocking',
        'DDoS protection and rate limiting',
        'SSL/TLS termination and encryption',
        'Compliance support for PCI DSS and other standards'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Web Application Firewall"
      subtitle="Advanced WAF solutions to protect web applications from common attacks and security vulnerabilities."
      sections={sections}
    />
  );
};

export default WAF;

